export class ExportedFile
{
    fileName: string;
}